<template>
  <button :class="classes" class="crop-button" type="button" v-on="$attrs">
    <CropIcon :border="true" :crop="crop" :theme="iconTheme" />
    <AppParagraph class="crop-button__name" size="sm">
      <TextContent :content="crop" />
    </AppParagraph>
  </button>
</template>

<script>
import AppParagraph from '@/components/shared/AppParagraph';
import CropIcon from '@/components/shared/CropIcon';
import TextContent from '@/components/shared/TextContent';

export default {
  components: {
    AppParagraph,
    CropIcon,
    TextContent
  },
  props: {
    crop: {
      type: String,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    classes() {
      return {
        'is-selected': this.isSelected
      };
    },
    iconTheme() {
      return this.isSelected ? 'primary' : 'white';
    }
  }
};
</script>

<style lang="scss" scoped>
.crop-button {
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: center;
  width: 4rem;

  @media print {
    display: none;

    &.is-selected {
      display: block;
    }
  }

  @include breakpoint('md') {
    &::after {
      background-color: color('black');
      content: '';
      height: 4rem;
      left: 50%;
      opacity: 0;
      position: absolute;
      top: 0;
      transform: translateX(-50%);
      transition: opacity 0.3s;
      width: 4rem;
    }
  }

  &:hover::after {
    opacity: 0.1;
  }

  &__name {
    font-family: $articulat-cf;
    line-height: 1.4;
    margin-top: spacing('xs');

    .is-selected & {
      font-family: $articulat-cf;
      font-weight: 600;
    }
  }
}
</style>
